import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { SnCheckboxFormField } from './components/form-field/checkbox.form-field';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatCheckboxModule,
    // Formly
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'checkbox',
          component: SnCheckboxFormField,
        },
      ],
    }),
  ],
  exports: [MatCheckboxModule],
  declarations: [SnCheckboxFormField],
})
export class SnFormCheckboxModule {}
